import { number, object, string } from "yup";

const AffiliatesSchema = object().shape({
  affiliateName: string().required("Vendos emrin e partnerit"),
  email: string().email("Email adresa nuk eshte valide").required("Vendos email adresen"),
  phoneNumber: string().required("Vendos numrin e telefonit"),
  promoCode: string().required("Vendos kodin promocional"),
  esimDiscountPercentage: number()
    .typeError("Vendos perqindjen e zbritjes per eSIM")
    .min(0, "Perqindja nuk mund te jete negative")
    .max(100, "Perqindja nuk mund te jete me e madhe se 100")
    .required("Vendos perqindjen e zbritjes per eSIM"),
  busTicketDiscountPercentage: number()
    .typeError("Vendos perqindjen e zbritjes per bileta")
    .min(0, "Perqindja nuk mund te jete negative")
    .max(100, "Perqindja nuk mund te jete me e madhe se 100")
    .required("Vendos perqindjen e zbritjes per bileta"),
  esimCommissionPercentage: number()
    .typeError("Vendos perqindjen e komisionit per eSIM")
    .min(0, "Perqindja nuk mund te jete negative")
    .max(100, "Perqindja nuk mund te jete me e madhe se 100")
    .required("Vendos perqindjen e komisionit per eSIM"),
  busTicketCommissionPercentage: number()
    .typeError("Vendos perqindjen e komisionit per bileta")
    .min(0, "Perqindja nuk mund te jete negative")
    .max(100, "Perqindja nuk mund te jete me e madhe se 100")
    .required("Vendos perqindjen e komisionit per bileta"),
  expirationDate: string().required("Vendos daten e skadimit")
});

export default AffiliatesSchema;
